export const colors = {
  primary: {
    gray: "#808080",
    pink: "#FB4296",
    purple: "#7A40CA",
    blue: "#414BB2",
    lightBlue: "#5EABFB",
    teal: "#1197A2",
  },
  pastel: {
    gray: "#E6E6E6",
    pink: "#FB96C4",
    purple: "#CAABF4",
    blue: "#B7BEFB",
    lightBlue: "#B3D9FB",
    teal: "#A0DEE5",
  },
};
